
import React, { Component } from "react";

import './stores.scss';

import GoogleMapReact from 'google-map-react';



class Marker extends Component {

    // static propTypes = {
    //     text: PropTypes.string
    // };

    constructor(props) {
        super(props);

        this.state = {
            marker: props.marker
        }
    }

    componentWillReceiveProps = (nextProps) => {
        // console.log(nextProps);
        this.setState({ marker: nextProps.marker, active: nextProps.active });
    }

    render() {

        let { marker, active } = this.state;

        let { onClick } = this.props;

        let m = require('./../../assets/images/marker.png');
        let mActive = require('./../../assets/images/marker-active.png');


        // console.log(this.props.hover);
        // const style = this.props.$hover ? greatPlaceStyleHover : greatPlaceStyle;

        return (
            <div onClick={() => { onClick(marker) }} className={`marker ${active ? 'active' : ''} ${marker.expanded ? 'marker-active' : 'marker-inactive'}`}>
                <div className="marker-info">

                    <p className="marker-caption">
                        {marker.caption}

                    </p>


                    <small className="marker-address">
                        {marker.address}
                    </small>
                </div>

                <img className="location" src={m}></img>

            </div >
        );
    }
}


export default class Stores extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
            markers: [
                {
                    caption: 'Bigmarket, JP Nagar',
                    address: '#602,15th Cross, 100 Feet Ring Road, Opp.6th Phase Last Bustop, J P Nagar, Bengaluru, Karnataka 560078',
                    lat: 12.9062513, lng: 77.5754918,
                    zoom: 13,
                    phone: '080-26647790/91 , MOB: 7829767601,9448621000',
                    gst: '29AAGFT0290D1Z9',
                    email: 'thebigmarket.bmj@gmail.com'
                }, {
                    caption: 'Bigmarket, JP Nagar 2',
                    address: '#78 & 79, 24th Main Road, 5th Phase,Puttenahalliward, Near Sobha Tulip Apartment, J. P. Nagar, Bengaluru, Karnataka 560078',
                    lat: 12.8983573, lng: 77.573048,
                    phone: '080-26633044/55, MOB : 7829767602,9886643857',
                    gst: '29AAGFT6021N1ZR',
                    email: 'thebigmarket.bmp@gmail.com',
                }, {
                    caption: 'Bigmarket, Off Hosur Main Road',
                    address: '#91/1, Anekal Road, Off Hosur Main Road, Near Bescom, Chandapura, Bangalore-560099',
                    lat: 12.7969844, lng: 77.7045339,
                    phone: '080-27832295/96 , Mob : 7829767633,9448623000',
                    gst: '29AAJFT1359C1Z4',
                    email: 'thebigmarket.bmc@gmail.com',
                }, {
                    caption: 'Bigmarket, Marsur',
                    address: '#194 & 195 B, Anekal-Chandapura Main Road, Near Vbhc Apartment, Marsur, Bengaluru-562106',
                    lat: 12.7793778, lng: 77.6871464,
                    phone: '08027827201/02, Mob : 9448624000',
                    gst: '29AAJFT1359C1Z4',
                    email: 'thebigmarket.bmm@gmail.com',
                }, {
                    caption: 'Bigmarket, Kanakapura Road',
                    address: '#55/3 & 14, Opp.Govt School, Doddakallasandra , Kanakapura Main Road,Bengaluru-560062',
                    lat: 12.8809953, lng: 77.5543245,
                    phone: '080-25560083/84, Mob : 9448945000',
                    gst: '29AAMFT1377R1Z4',
                    email: 'thebigmarket.bmd@gmail.com',
                }, {
                    caption: 'Bigmarket, Sarjapur Main Road',
                    address: 'Near Lakshmi Conventional Hall, Sarjapur Main Road, Attibelle, Bengaluru-562107',
                    phone: '080-27844122, 23 Mobs: 9448468777',
                    gst: '29AANFT9923E1ZM',
                    lat: 12.8607163, lng: 77.7777879,
                    email: 'thebigmarket.bmh@gmail.com',
                }, {
                    caption: 'Bigmarket, Sahakar Nagar',
                    address: '#26/1, G Block, Ground Floor,Spoorthi Complex, Sahakar Nagar, Bangalore-560092',
                    phone: '080-41735013,14 Mob:9916101661',
                    lat: 13.0624087, lng: 77.5908122,
                    email: 'thebigmarket.bmsn@gmail.com',
                }, {
                    caption: 'Bigmarket, Kodigehalli',
                    address: '#2,Kodigehalli,Thindlu Main Road,Near Bustop,Bangalore -560097',
                    phone: '080-23645510/40950087, Mob : 7760272879',
                    lat: 13.0636351, lng: 77.5700154,
                    email: 'thebigmarket.bmsn@gmail.com',
                }, {
                    caption: 'Bigmarket, Dwaraka Nagar',
                    address: '#153/2 , Dwaraka Nagar, Baglur Main Road, Bangalore -560063',
                    phone: '080-28478100, Mob : 8050101072',
                    lat: 13.1205554, lng: 77.6141209,
                    email: 'thebigmarket.bglr@gmail.com',
                }, {
                    caption: 'Bigmarket, Hennur Main Road',
                    address: '#1&2, Opp.XLR8, Hennur Main Road, Kothanur, Bengaluru-560077',
                    phone: '080-28465619Mob:9916101656',
                    lat: 13.0702764, lng: 77.6496613,
                    email: 'thebigmarket.bmk@gmail.com',
                }, {
                    caption: 'Bigmarket, Doddaballapur',
                    address: '#60/1, Doddaballapur Main Road,Opp.Bhagini Restaurant,Singanaykanahalli, Yelahanka,Bengaluru-560064',
                    phone: '080-29529005,Mob :7403008000',
                    lat: 13.1445062, lng: 77.5697027,
                    email: 'thebigmarket.bmy@gmail.com',
                }, {
                    caption: 'SHOPPY MART(PURVA HIGHLAND)',
                    address: '#19, Club House 2, Near E Block,  Purava Highland Apartment Mallasandra Village, Uttarahalli Hobli, Bengaluru-560062',
                    phone: '7829767611',
                    lat: 12.8539874, lng: 77.5423112,
                    email: 'thebigmarketco@gmail.com',
                }, {
                    caption: 'SHOPPY MART (PRESTIGE ROYAL GARDEN)',
                    address: 'Avalahalli,Doddaballapur main road,Yelahanka, Bangalore-560064',
                    // phone: '7829767611',
                    lat: 13.1397338, lng: 77.5674621,
                    // email: 'thebigmarketco@gmail.com',
                }, {
                    caption: 'SHOPPY MART(PRESTIGE MISTY WATER)',
                    address: 'Kempapura Main Road, Hebbal, Bangalore-560064',
                    // phone: '7829767611',
                    lat: 13.0360859, lng: 77.5979278,
                    // email: 'thebigmarketco@gmail.com',
                }, {
                    caption: 'FINE FARE DEPARTMENTAL STORE',
                    address: '#669,Opp.BDA Complex, 2nd Block, HBR Layout,Bengaluru-560043',
                    phone: '80-25446464,25440408 ',
                    email: 'finefairdepartmentals@gmail.com',
                    lat: 13.0253239, lng: 77.6277155,
                    // email: 'thebigmarketco@gmail.com',
                }, {
                    caption: 'FINE FARE SUPER MARKET',
                    address: '#9,8TH Main,80Feet Road ,HBR Layout, Bengaluru-560043,560043',
                    phone: '08025450570',
                    email: 'finefairdepartmentals@gmail.com',
                    lat: 13.0208405, lng: 77.6215876,
                }, {
                    caption: 'FINE FARE HOME CENTRE',
                    address: '#290/1,7th Main Road, 80Feet Road,HBR Layout, Bengaluru-560043                    ',
                    phone: '080-25452644',
                    email: 'finefairdepartmentals@gmail.com',
                    lat: 13.0258003, lng: 77.6256063,
                }]
        };
    }

    loadMap = () => {
        const { markers } = this.state;

        this.viewMarker(markers[0], 0);
    }

    viewMarker = (marker, index) => {
        let { markers, activeMarker } = this.state;
        activeMarker = marker;
        markers.forEach((marker) => {
            marker.expanded = false;
        })
        markers[index].expanded = true;


        this.setState({ markers, activeMarker, activeIndex: index });
    }

    render() {

        let center = {
            center: {
                lat: 12.976750,
                lng: 77.575280
            },
            zoom: 16
        };

        let { markers, activeMarker, activeIndex } = this.state;

        // return (
        //     <div className="">

        //     </div>
        // )

        return (
            <div className="stores">
                <div className="page-content">
                    <h1 className="page-heading">
                        Stores
                    </h1>

                    <p className="page-desc">
                        We have {markers.length} bigmarket stores around Bangalore so far spread over each nook and corner.
                    </p>
                </div>

                <div className="stores-container" style={{ height: '100vh', width: '100%' }}>
                    <GoogleMapReact
                        options={{ scrollwheel: false }}
                        center={activeMarker}
                        bootstrapURLKeys={{ key: 'AIzaSyCVBthtEmWi0Ul8mejDQrBlOULXB1kTB3I' }}
                        defaultCenter={center.center}
                        yesIWantToUseGoogleMapApiInternals={true}
                        onGoogleApiLoaded={() => {
                            console.log('loaded');
                            this.loadMap();
                        }}
                        defaultZoom={center.zoom}>

                        {
                            // .filter((marker) => { return marker.expanded })
                            markers.map((marker, index) => {
                                return (<Marker
                                    onClick={(marker) => {
                                        this.viewMarker(marker, index);
                                    }}
                                    active={index === activeIndex}
                                    marker={marker}
                                    lat={marker.lat}
                                    lng={marker.lng}
                                    text={marker.caption}
                                />)
                            })
                        }

                    </GoogleMapReact>

                    <div className="list-group">

                        {/* Marker Right bar */}

                        <div className="list-group-item store-heading">
                            <h6 className="marker-heading">{markers.length} Stores in Bangalore</h6>
                        </div>

                        {
                            markers.map((marker, index) => {
                                return (<a key={index} onClick={() => { this.viewMarker(marker, index) }} className={`marker list-group-item list-group-item-action ${marker.expanded ? 'marker-active' : 'marker-inactive'}`} >
                                    <div class="marker-detail">
                                        <h6 class="mb-1 marker-caption">{marker.caption}</h6>
                                        <small>
                                            {marker.address}
                                        </small>
                                        {/* <small>3 days ago</small> */}
                                    </div>
                                    {/* <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p> */}
                                    {/* <small>Donec id elit non mi porta.</small> */}
                                </a>)
                            })
                        }
                    </div>
                </div>
            </div >)
    }
}
